import { View, Image, Text } from '@react-pdf/renderer';
import { headerStyle } from './style';
import { BaseUserOnProject } from '..';

interface IHeader extends BaseUserOnProject {
    clientName: string;
    period: string;
}

export const Header = ({ clientName, projectName, memberName, memberLastName, period }: IHeader) => {
    const trimmedClientName = clientName.trim();
    const trimmedProjectName = projectName.trim();
    const trimmedMemberName = memberName.trim();
    const trimmedMemberLastName = memberLastName.trim();

    const memberFullName = [trimmedMemberName, trimmedMemberLastName].filter(Boolean).join(' ');

    return (
        <View style={headerStyle.header}>
            <View style={headerStyle.info}>
                <Text style={headerStyle.organizationName}>{trimmedClientName}</Text>
                <Text style={headerStyle.project}>{trimmedProjectName}</Text>
                {memberFullName && <Text style={headerStyle.project}>{memberFullName}</Text>}
                <Text style={headerStyle.period}>{period}</Text>
            </View>
            <Image style={headerStyle.image} src="/img/fornulio-logo.jpg" />
        </View>
    );
};
